import dayjs from 'dayjs';
import type { CustomerProductList } from '../../../bff-api/customers/model';
import type { Attendee } from '../models/Attendee';
import type { CartCulinaryProductItem } from '../models/CartCulinaryProductItem';

export const saveForLaterContainsProduct = (
    saveForLaterList: CustomerProductList | undefined,
    productId: string,
): boolean =>
    !!saveForLaterList?.customerProductListItems?.some((item) => item.productId === productId);

export const getProductItemAttendees = (
    culinaryItem: CartCulinaryProductItem,
): { attendees: Attendee[] } =>
    JSON.parse(culinaryItem?.c_attendeeDetails || '{"attendees":  []') as { attendees: Attendee[] };

export const isExpiredCulinaryClass = (
    productItem: CartCulinaryProductItem,
    classBlockedThreshold: number,
): boolean => {
    if (productItem.c_culinaryClass?.dateAndTime) {
        const culinaryDate = dayjs(productItem.c_culinaryClass?.dateAndTime);

        if (culinaryDate && culinaryDate.isValid()) {
            const now = dayjs();
            const diffInSeconds = culinaryDate.diff(now, 'second');

            if (diffInSeconds < 0) {
                return true;
            }

            const thresholdSeconds = (classBlockedThreshold ?? 0) * 60;

            return diffInSeconds <= thresholdSeconds;
        }
    }

    return false;
};

export const isProductInSaveForLater = (
    productId: string,
    saveForLaterData?: CustomerProductList,
): boolean =>
    !!saveForLaterData?.customerProductListItems?.find(
        (product) => product.productId === productId,
    );

export const prepareAccordionContentAsset = (assetString: string) => {
    if (assetString) {
        const match = assetString.match(/<p><strong>.*?<\/strong><\/p>/);
        let title = '';
        if (match) {
            [title] = match;
        }

        const remainingContent = assetString.replace(title, '').trim();

        return {
            title,
            remainingContent,
        };
    }

    return {
        title: '',
        remainingContent: '',
    };
};
